module.exports = __webpack_public_path__ + "img/homeTitle.4b741a4e.png";